import React, {useState} from 'react';
import {HomeHeaderSlider} from "./HomeHeaderSlider";
import {Activity} from "./Activity";
import {News} from "./News";
import {Map} from "./Map";
import {Statistic} from "./Statistic";
import {Partners} from "./Partners";
import Location from './Location';

import style from  "../contacts/assets/style.module.css";

import BounceLoader from "react-spinners/BounceLoader";
import reactSeo from '../../reactSeo';


export function Home() {
  const [loader, setLoader] = useState(true)
const loaderT=()=>{
    setTimeout(()=>{
        setLoader(false)
    }, 1000)
}
    return (
        <div onLoad={()=>{loaderT()}}>
      {reactSeo()}
            <HomeHeaderSlider/>
            <Activity />
            <Statistic />
            <News />
            <Map />
            <Partners />
            <Location/>
        </div>
    );
}

